import Vue from 'vue';
import Component from 'vue-class-component';

import searchIcon from 'assets/icons/search_icon_new.svg';
import SearchResultSlug from 'components/SearchResultSlug/SearchResultSlug.vue';

@Component({
  props: {
    isPredictive: {
      type: Boolean,
      default: false,
      description: 'Boolean if show empty query or predictive',
    },
    activitiesSearchResults: {
      required: false,
      description: 'Activities objects from search',
    },
    suggestionsResults: {
      required: true,
      description: 'Suggestions to display',
    },
    searchValue: {
      required: false,
      description: 'Actual predictive search text',
    },
    loading: {
      required: true,
      type: Boolean,
    },
    isSpain: {
      required: true,
      type: Boolean,
    },
    allSearchResults: {
      required: false,
      type: Array,
    },
    containBoxesFlag: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  components: {
    SearchResultSlug,
  },
})
export default class SearchOptionsComponent extends Vue {
  searchIcon = searchIcon;



  
  isBoxProduct(product) {
    return product?.child_type === 'Box';
  }

  isComboActivity(product) {
    return product?.child_type === 'ComboActivity';
  }

  isPartnerActivity(product) {
    return product?.child_type === 'PartnerActivity';
  }

  isProvinceType(product) {
    return product?.__typename === 'FilteredProvinceType';
  }

  getProductTypes(product) {
    return {
      isBox: this.isBoxProduct(product),
      isComboActivity: this.isComboActivity(product),
      isPartnerActivity: this.isPartnerActivity(product),
      isProvinceType: this.isProvinceType(product),
    };
  }

  /**
   * Crea la estructura base de un producto
   */
  createBaseProduct(product, { isBox }) {
    return {
      id: product?.id,
      name: product?.name,
      child_type: product.child_type || 'Box',
      product_url: isBox
        ? product.box?.product_url
        : product.partneractivity?.product_url,
      category: isBox
        ? product.box?.category
        : product.partneractivity?.category,
      ...(isBox && {
        count_activities_available_and_visible:
          product.box?.count_activities_available_and_visible,
      }),
    };
  }

  applyProductAdjustments(baseProduct, product, productTypes) {
    const result = { ...baseProduct };

    if (productTypes.isProvinceType) {
      result.category = 'Location';
      result.child_type = product.__typename;
      result.product_url = this.getUrlWithLocationParams('', { province: result.name });
    }

    if (
      productTypes.isPartnerActivity &&
      result.category?.name === 'Ocasiones'
    ) {
      result.category.name = result.name;
    }

    if (productTypes.isComboActivity) {
      result.product_url = product.comboactivity?.product_url;
      result.category = product.comboactivity?.category;
    }

    return result;
  }

  transformProduct(product) {
    const productTypes = this.getProductTypes(product);
    const baseProduct = this.createBaseProduct(product, productTypes);
    return this.applyProductAdjustments(baseProduct, product, productTypes);
  }

  /**
   * Generates URL with proper currentFilters format expected by the filter system
   * @param {string} keywords - Search keywords
   * @param {Object} filters - Filter object (e.g., { province: "Buenos Aires" })
   * @returns {string} Properly formatted URL
   */
  getUrlWithLocationParams(keywords, filters = {}) {
    // Determinar el tipo de card basado en containBoxesFlag
    const cardType = this.containBoxesFlag ? 0 : 1;
    
    // Crear estructura de currentFilters con formato completo: [BOX, ACTIVITY, TRAVEL_UY]
    //TODO import from const to avoid duplication code...
    const currentFilters = [
      {
        // BOX filters (índice 0)
        category_name: [],
        participants: [],
        price: [],
        province: [],
        cities: []
      },
      {
        // ACTIVITY filters (índice 1) 
        price: [],
        has_online_reservation: false,
        category_name: [],
        subcategory_name: [],
        participants: [],
        province: [],
        cities: []
      },
      {
        // TRAVEL filters (índice 2)
        price: [],
        has_online_reservation: false,
        participants: [],
        province: [],
        cities: []
      }
    ];
    
    // Aplicar filtros al tipo de card correspondiente si existen
    if (filters && Object.keys(filters).length > 0) {
      Object.keys(filters).forEach(key => {
        const value = filters[key];
        // Verificar que la propiedad existe en el filtro del cardType
        if (Object.prototype.hasOwnProperty.call(currentFilters[cardType], key)) {
          currentFilters[cardType][key] = Array.isArray(value) ? value : [value];
        }
      });
    }
    
    const queryParams = {
      card: cardType,
      currentFilters: JSON.stringify(currentFilters),
    };
    
    // Agregar keywords si existe
    if (keywords) {
      queryParams.keywords = keywords;
    }
    
    const location = this.$router.resolve({
      name: 'products',
      query: queryParams,
    });
    
    return location.href;
  }

  get searchText() {
    return this.isSpain
      ? 'Busca resultados de '
      : ' Ver todos los resultados de ';
  }

  /**
   * Computed property que transforma la lista de productos
   */
  get parseProductListResult() {
    return (
      this.allSearchResults?.map(product => this.transformProduct(product)) ||
      []
    );
  }
}
